module.exports = __webpack_public_path__ + "static/img/fish10.b88306e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish/fish10.png
// module id = PZNB
// module chunks = 0